<app-navbar></app-navbar>

<!-- Top Banner Section Start -->
<div class="mb-10 banner-container">
  <div class="grid grid-cols-12">
      <div class="col-span-12">
          <div class="w-full h-[450px] banner-wrapper">
              <img src="/assets/images/banners/booking-banner.png" alt=""
                  class="object-cover w-full h-full">
                  <div class="flex items-center h-full banner-container-inner">
                      <div class="container mx-auto">
                          <div class="p-[30px] text-center mt-[7em]">
                              <h1 class="my-0 mb-2 text-[2em] sm:text-5xl md:text-[2.5em] text-white">
                                  <span class="font-bold mr-2">Book Appointment</span>
                              </h1>
                          </div>
                      </div>
                  </div>
          </div>
      </div>
  </div>
</div>
<!-- Top Banner Section End -->

<!-- Doctor Details and Booking Form Section -->
<div class="container mx-auto mt-8 mb-8 min-h-screen doctor_details_container">
  <ngx-spinner bdColor="rgba(256, 256, 256, 0.7)" size="default" color="#6eabc6" type="ball-spin-fade"
    [fullScreen]="true">
    <p style="color: black"> Please wait... </p>
  </ngx-spinner>
  <div class="md:custom-margin grid grid-cols-1 lg:grid-cols-12 gap-0 lg:gap-4">
    <!-- Doctor Profile Card -->
    <div class="md:col-span-4 lg:col-span-4 md:mx-4 w-full h-full p-5 mb-5 relative">
      <div class="gap-4 rounded" id="doctor-profile-card">
        <div class="h-[450px] text-center">
          <img class="w-full h-full doctor-image object-cover object-top rounded-t-3xl"
            [src]="doctor?.image !== 'https://medeaseadmin.onetikk.org/storage/' ? doctor?.image : '/assets/images/icons/doctor-default-img.png'"
            alt="{{doctor?.title}}">
        </div>
        <div
          class="bg-[#031b4e] bg-[url('/assets/images/card-bg.png')] bg-contain bg-repeat bg-bottom-center p-[40px] doctor_details_bg relative">
          <div>
            <div class="name_details pb-[30px] border-b-2 border-[#ffffff1a]">
              <h2 class="text-xl text-white font-bold my-2">Dr. {{doctor?.title}}</h2>
              <div class="text-md text-white relative pl-[12px] doctor_title">{{doctor?.designation}}</div>
            </div>
            <div class="doctor_contact-details">
              <div class="text-gray-700 mt-2">
                <h4 class="my-0 text-base font-light text-[#3368c6]">SPECIALITY:</h4>
                <span class="mr-1 text-white font-normal">{{doctor?.specialty}}</span>
              </div>
              <!-- <div class="text-gray-700 mt-4">
                <h4 class="my-0 text-base font-light text-[#3368c6]">EMAIL ADDRESS:</h4>
                <span class="font-normal text-white mr-1">joshua&#64;123.com</span>
              </div> -->
              <div class="text-gray-700 mt-4">
                <h4 class="my-0 text-base font-light text-[#3368c6]">QUALIFICATION:</h4>
                <span class="font-normal text-white mr-1">{{doctor?.qualification}}</span>
              </div>
              <div class="text-gray-700 mt-4">
                <h4 class="my-0 text-base font-light text-[#3368c6]">EXPERIENCE:</h4>
                <span class="font-normal text-white mr-1">{{doctor?.experience}}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Booking Form -->
    <div
      class="w-full md:col-span-8 lg:col-span-8 mx-auto shadow-lg p-5 rounded-lg border border-solid border-slate-200"
      *ngIf="accessToken">
      <h1 class="text-black text-center font-semibold">Book an Appointment</h1>
      <p class="text-center font-medium">Fill patient details and Select your slot</p>
      <mat-stepper class="booking-stepper sm:p-0 md:p-0 lg:p-6 rounded-xl no-clickable" orientation="horizontal" [linear]="true"
        #stepper [orientation]="(stepperOrientation | async)!" [disableRipple]="true" (selectedIndexChange)="onStepChange($event)">

        <!-- Step 1: Patient Information -->
        <mat-step [completed]="isCompleted" label="booking-info" #stepOne>
          <div class="count-wrapper">
            <form [formGroup]="countForm" class="flex flex-col">
              <ng-template matStepLabel>Patient Information</ng-template>
              <div class="personal-info mb-12">
                <div class="personal-input">
                  <div class="select-patient mb-[2em]" *ngIf="allPatients.length > 0">
                    <h4 class="text-lg font-medium">Select Patient</h4>
                    <div class="revisit-patient-container flex items-center flex-wrap">
                      <!-- <div
                        class="revisit-patient-card bg-[#f1f2f6] h-[60px] rounded-[10px] mr-4 flex justify-center items-center sm:w-[220px] md:w-[200px] lg:w-[180px] xl:w-[150px] mb-[10px] cursor-pointer hover:bg-[#1cba9f]"
                        *ngFor="let patient of allPatients;">
                        <h4 class="text-black font-normal text-base" (click)="getPatientData(patient.id)">
                          {{patient.name}}</h4>
                      </div> -->
                      <div class="w-full">
                        <mat-form-field class="w-full">
                          <mat-label>Select Existing Patient</mat-label>
                          <mat-select formControlName="patient">
                            <mat-option *ngFor="let patient of allPatients;" value="{{patient.id}}"
                              (click)="getPatientData(patient.id)">{{patient.name}}</mat-option>
                          </mat-select>
                        </mat-form-field>
                      </div>
                    </div>
                    <div class="or-sec text-center mt-[4em]">
                      <span>OR</span>
                    </div>
                  </div>
                  <h4 class="text-lg font-medium">Fill Patient Details</h4>
                  <mat-form-field appearance="fill" color="primary">
                    <mat-label>Name</mat-label>
                    <input type="text" matInput formControlName="name">
                    <mat-error *ngIf="f.name.invalid" class="mb-2 text-sm">Please enter a valid name</mat-error>
                  </mat-form-field>
                  <mat-form-field>
                    <mat-label>Select Gender</mat-label>
                    <mat-select formControlName="gender">
                      <mat-option value="1">Male</mat-option>
                      <mat-option value="0">Female</mat-option>
                    </mat-select>
                    <mat-error *ngIf="f.gender.invalid" class="mb-2 text-sm">Please select a gender</mat-error>
                  </mat-form-field>
                  <mat-form-field>
                    <mat-label>Enter Date of Birth</mat-label>
                    <input matInput [matDatepicker]="picker3" formControlName="dob">
                    <mat-hint class="mat-hint-style">MM/DD/YYYY</mat-hint>
                    <mat-datepicker-toggle matIconSuffix [for]="picker3"></mat-datepicker-toggle>
                    <mat-datepicker #picker3></mat-datepicker>
                    <mat-error *ngIf="f.dob.invalid" class="mb-2 text-sm">Please enter a valid date of birth</mat-error>
                  </mat-form-field>
                  <mat-form-field appearance="fill" color="primary">
                    <mat-label>MR Number</mat-label>
                    <input type="number" matInput formControlName="mrNumber">
                    <mat-error *ngIf="f.mrNumber.invalid" class="mb-2 text-sm">Please enter a valid MR
                      number</mat-error>
                  </mat-form-field>
                </div>
              </div>
            </form>
            <div class="text-center">
              <mat-checkbox [(ngModel)]="isRevisit" [ngModelOptions]="{standalone: true}" [checked]="revisit" class="mt-3" *ngIf="allPatients.length > 0">
                <h4 class="text-start mb-2 text-lg font-medium">Is Follow-up Appointment?</h4>
                <p class="my-0 text-start w-[80%] leading-6">
                  For a follow-up visit, a fee of Rs 15 is required if your last appointment was within the past 7 days. However, if your last appointment was more than 7 days ago, or if you've already revisited once, you will be charged Rs 35. For new appointments, the fee is also Rs 35.
                </p>
              </mat-checkbox>
            </div>
            <div class="">
              <mat-checkbox [(ngModel)]="isChecked" [ngModelOptions]="{standalone: true}" [checked]="isChecked" class="mt-3">
                <h4 class="text-start mb-2 text-lg font-medium">Whatsapp Notification</h4>
                <p class="my-0 text-start w-[100%] leading-6">
                  Enable WhatsApp notifications for updates and reminders.
                </p>
              </mat-checkbox>
            </div>
          </div>
          <div class="button-wrapper text-center w-100 my-10 mx-auto">
            <button spinnerButton [loading]="isLoading" mat-flat-button color="primary" (click)="goToSlot()"
              [disabled]="countForm.invalid">
              <span class="text-white" *ngIf="!isLoading">Next</span>
            </button>
          </div>
        </mat-step>

        <!-- Step 2: Select Slot -->
        <mat-step label="booking-slot" #stepTwo>
          <ng-template matStepLabel>Select slot</ng-template>
          <div class="slot-selection">
            <app-slot-selection #slotSelector [slotCheckCount]="slotCheckCount" [bookingData]="bookingData"
              [isChild]="isChild" [doctorId]="doctorId" [doctorBranchId]="doctorBranchId" [slots]="slots"
              [datesToHighlight]="datesToHighlight" [isLoading]="isLoading" [patientId]="patientId" [isRevisit]="isRevisit" (stepperNextEvent)="summary($event)"
              *ngIf="modalReady && datesToHighlight?.length > 0"></app-slot-selection>
          </div>
          <div class="button-wrapper text-center w-100 my-10 mx-auto">
            <button mat-flat-button color="primary" (click)="calendarBack()"><span
                class="text-white">Back</span></button>
          </div>
        </mat-step>

        <!-- Step 3: Confirm & Pay -->
        <mat-step label="booking-summary" #stepThree>
          <ng-template matStepLabel>Confirm & Pay</ng-template>
          <div class="my-10 mx-auto sm:w-full md:w-full lg:w-4/5 booking-summary">
            <app-booking-summary *ngIf="bookingData" [details]="bookingData" [isRevisit]="isRevisit"></app-booking-summary>
          </div>
          <div class="button-wrapper text-center w-100 my-10 mx-auto">
            <button class="mr-5" mat-stroked-button color="primary" matStepperPrevious>Back</button>
            <button spinnerButton [loading]="isLoading" mat-flat-button color="primary" (click)="slotRegistration()"
              [disabled]="countForm.invalid || isLoading">
              <span class="text-white" *ngIf="!isLoading">Confirm & Pay</span>
            </button>
          </div>
        </mat-step>
      </mat-stepper>
    </div>
    <div
      class="mt-10 w-full md:col-span-8 lg:col-span-8 mx-auto shadow-lg p-5 rounded-lg border border-solid border-slate-200"
      *ngIf="!accessToken">
      <div class="mt-10 container mx-auto p-[1em] md:p-[2em] lg:p-[8em] custom-border login-sec">
        <div class="flex">
          <img src="/assets/images/icons/login-icon.png" alt="" class="object-contain w-[50px] h-[50px]">
         <div class="ml-[2em]">
          <p class="text-black text-[1.3em] font-medium mt-0 mb-2">
            "Sorry, You are not logged in. Please login to make a booking."
          </p>
          <p class="text-[#7b7171] text-[1.1em] mt-0 w-[90%] font-normal">
            In order to book a doctor, you must first be logged in to your account. Please click the login button
            provided below to access your account and proceed with booking your appointment.
          </p>
          <div class="">
            <button (click)="goToLogin()" class="view-doctors inline-block rounded-[6px]">
              Login</button>
          </div>
         </div>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- Mat Spinner  -->
<app-message></app-message>
<app-footer></app-footer>
